'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var InternalInputCaption_web = require('../../internal/InternalTextInput/InternalInputCaption/InternalInputCaption.web.cjs');

/**
 * Descriptive text displayed below an input for extra clarification or error state
 *
 * {@link https://aviary.fullscript.io/latest/components/input-caption/web-YBEQNZbA | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/InputCaption/InputCaption.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const InputCaption = ({ customCss, ...rest })=>{
    return /*#__PURE__*/ jsxRuntime.jsx(InternalInputCaption_web.InternalInputCaption, {
        css: customCss,
        ...rest
    });
};

exports.InputCaption = InputCaption;
//# sourceMappingURL=InputCaption.web.cjs.map
